import notes from './notes'
import students from './students'
import tests from './tests'
export default {
    notes,
    students,
    tests,
}